import React from "react";
import { TextField } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';

import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useField } from "react-final-form-hooks";
import './index.css';

export default function ({ form, name, label, icon, margin= 'normal', type = 'text', children, hint, hidden, ...props }) {
    const field = useField(name, form);

    if(hidden){
        return null;
    }


    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimePicker
          {...field.input}
          format="yyyy-MM-dd h:mm a"
          clearable
          TextFieldComponent={(innerProps) => <TextField
            {...innerProps}
            margin={margin}
            label={label}
            fullWidth
            type={type}
            size="small"
            variant="outlined"
            error={field.meta.touched && field.meta.error}
            helperText={(field.meta.touched) ? field.meta.error : null}
            {...props}
          />}
        />
      </MuiPickersUtilsProvider>
    );
}
